module.exports = ":host {\n  display: block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/cell-templates/cell-templates.component.css
// module id = ./src/app/examples/cell-templates/cell-templates.component.css
// module chunks = main